
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PoPo05PendingPIforIrDialog extends Serenity.EntityDialog<PoPo05PendingPIforIrRow, any> {
        protected getFormKey() { return PoPo05PendingPIforIrForm.formKey; }
        protected getIdProperty() { return PoPo05PendingPIforIrRow.idProperty; }
        protected getLocalTextPrefix() { return PoPo05PendingPIforIrRow.localTextPrefix; }
        protected getNameProperty() { return PoPo05PendingPIforIrRow.nameProperty; }
        protected getService() { return PoPo05PendingPIforIrService.baseUrl; }
        // protected getDeletePermission() { return PoPo05PendingPIforIrRow.deletePermission; }
        // protected getInsertPermission() { return PoPo05PendingPIforIrRow.insertPermission; }
        // protected getUpdatePermission() { return PoPo05PendingPIforIrRow.updatePermission; }

        protected form = new PoPo05PendingPIforIrForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
         
             let newCloseBtn: Serenity.ToolButton =
            {
                title: Q.text("ปิดเอกสาร"),
                hint: "Close Document",
                separator: false,
                cssClass: "closed-button",
                icon: "fa fa-save",
                onClick: (e) => {
                    Q.confirm('ยืนยันการปิดเอกสาร', () => {
                        // this.doDelete(() => {
                        console.log("Document Closed",this.form.SysDocNo.value);
                        //     this.dialogClose();
                        // });
                        Q.serviceRequest('Purchase/PoPurInvoice/UpdateCancelAndIrUseFg', {
                            sysDocNo: this.form.SysDocNo.value,
                            CancelFg: "1",
                            IrUseFg: 1
                        }, response => {
                            Q.notifySuccess("ปิดเอกสารเรียบร้อยแล้ว");
                            this.dialogClose();
                        }, {
                            onError: (response) => {
                                Q.notifyError("เกิดข้อผิดพลาดในการปิดเอกสาร");
                            }
                        });

                    });
                }
            };
            buttons.push(newCloseBtn);
           return buttons;


   }
    }
}